import { isIOS, isWechat } from './F';
import RQ from './request';

import wx from 'weixin-js-sdk';

const DEBUG = false;

/**
 * https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421141115
 */
export async function configFactory(route, run) {
  console.log('location.href  ------>', location.href, route);
  if (!isWechat()) return;
  const url = isIOS() ? G.entryUrl.split('#')[0] : (location.origin + route.fullPath).split('#')[0];
  if (!G.enterprise) return;
  console.log('url      -------> ', url);
  const signRes = await RQ.mall.get('/api/h5/wechat/getJSSign', {
    url: encodeURIComponent(url),
    isPlatform: G.is_platform !== undefined ? G.is_platform : 0,
    debug: DEBUG
  });
  console.log('getJSSign signRes  -------> ', signRes);

  if (signRes.code == 0) {
    const signData = signRes.data;

    wx.config({
      debug: DEBUG, // 开启调试模式,调用的所有api的
                    // 返回值会在客户端alert出来，若要查看传入的参数，
                    // 可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: signData.appId, // 必填，公众号的唯一标识
      timestamp: signData.timestamp, // 必填，生成签名的时间戳
      nonceStr: signData.nonceStr, // 必填，生成签名的随机串
      signature: signData.signature, // 必填，签名，见附录1
      jsApiList: signData.jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });

    wx.error((err) => {
      console.log('wechat config error:', err);
    });

    wx.ready(() => {
      run && run();
    });
  } else {
    console.error('获取sign失败');
  }
}

/**
 * 微信分享功能
 * @param shareData
 *    title: '', // 分享标题
 *    desc: '', // 分享描述
 *    link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
 *    imgUrl: '', // 分享图标
 *    type: '', // 分享类型,music、video或link，不填默认为link
 *    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
 * @param success
 * @param cancel
 * @returns {Promise.<void>}
 */
export async function share(route, shareData, success = () => null, cancel = () => null, trigger = () => null) {
  console.log('shareData---', shareData);
  configFactory(route, () => {
    ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone', 'onMenuShareWeibo'].forEach((v) => {
      wx[v]({
        ...shareData,
        success: function (data) {
          console.log('success---> ', v);
          success(v, data);
        },
        cancel: function () {
          console.log('cancel---> ', v);
          cancel(v);
        },
        trigger: function (e) {
          console.log('trigger---> ');
          trigger(v);
        },
        fail: function (e) {
          console.log('fail---> ', v);
        },
        complete: function (e) {
          console.log('complete---> ');
        }
      });
    });
    wx.showOptionMenu();
  });
}

/**
 * 隐藏微信菜单
 * @param pageUrl
 * @returns {Promise.<void>}
 */
export async function hideOptionMenu(route) {
  configFactory(route, () => {
    wx.hideOptionMenu();
  });
}

/**
 * 微信扫码功能
 * @param success
 * @param cancel
 * @returns {Promise.<void>}
 */
export async function scanCode(route, success = () => null, error = () => null) {
  configFactory(route, () => {
    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res) {
        success(res.resultStr || ''); // 回调
      },
      fail: function (err) {
        if (err.errMsg.indexOf('function_not_exist') > 0) {
          alert('版本过低请升级');
        }
        error(err);
      }
    });
  });
}

/**
 * 调起微信支付
 * @param payData
 *    timestamp: 0, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。
 *                  // 但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
 *    nonceStr: '', // 支付签名随机串，不长于 32 位
 *    package: '', // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
 *    signType: '', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
 *    paySign: '', // 支付签名
 *
 * @param success
 * @param error
 * @param cancel
 * @returns {Promise.<void>}
 */
export async function pay(route, payData, success = () => null, error = () => null, cancel = () => null) {
  configFactory(route, () => {
    wx.chooseWXPay({
      // ...payData,
      timestamp: payData.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
      nonceStr: payData.nonceStr, // 支付签名随机串，不长于 32 位
      package: payData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
      signType: payData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
      paySign: payData.paySign, // 支付签名
      success,
      fail: error,
      cancel
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/wx.js